import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { PerformanceComponent } from './performance/performance.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { BrowserInfoComponent } from './browser-info/browser-info.component';
import { FormsModule } from '@angular/forms';

import { authConfig } from 'environments/environment';
import { SecurityModule } from '@app/core/security/security.module';
import { KeycloakService } from './core/security/service/keycloak/keycloak.service';


@NgModule({
  declarations: [
    AppComponent,
    PerformanceComponent,
    BrowserInfoComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    CoreModule,
    DashboardModule,
    NgxDatatableModule,
    NgxBarcode6Module,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (keycloak: KeycloakService)  => () => keycloak.init(),
      deps: [ KeycloakService ],
      multi: true
    }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
}
